import React from 'react'

import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'
import { withRouter }         from 'react-router-dom'

import './styles.scss'

import {on_top_notification_changed} from '../../actions/content-alert-actions.js'

class ContentAlert extends React.Component{

  constructor (props) {
    super(props)

    this.state = {
      alert_content :{
        message           : '',
        button_text        : 'Okay',
        notification_type : 'warning',  // info, warning, error
        on_click          : null
      }
    }
  }

  componentWillReceiveProps(props) {
    this.setState({alert_content : props.contentAlert})
  }

  render() {
    const {message, button_text, notification_type, on_click} = this.state.alert_content

    return message ? (
      <div className='gradient-notification'>
        <p>{message}</p>
        <button onClick={on_click}>{button_text}</button>
      </div>
    ) : null
  }
}

export default withRouter(connect(({auth, contentAlert}) => {
  return {
    contentAlert,
    user: auth.user
  }
}, (dispatch) => bindActionCreators({on_top_notification_changed}, dispatch))(ContentAlert))





/*
export default ({message, buttonText, onClick}) => {
  return message ? (
    <div className='gradient-notification'>
      <p>{message}</p>
      <button onClick={onClick}>{buttonText}</button>
    </div>
  ) : null
}
*/
